import { create } from "zustand";
import { createCitiesSlice } from "../sub-slices/general/citiesSlice";
import { createContactSlice } from "../sub-slices/general/contactSlice";
import { createNewTicketSlice } from "../sub-slices/general/newTicketSlice";
import { createNotificationsSlice } from "../sub-slices/general/notificationsSlice";
import { createProvincesSlice } from "../sub-slices/general/provincesSlice";
import { createTicketDetailsSlice } from "../sub-slices/general/ticketDetailsSlice";
import { createTicketsSlice } from "../sub-slices/general/ticketsSlice";
import { createUserInfoSlice } from "../sub-slices/general/userInfoSlice";
import { createViewSlice } from "../sub-slices/general/viewSlice";

export const useGeneralStore = create((set, get) => ({
    ...createViewSlice(set, get),
    ...createProvincesSlice(set, get),
    ...createCitiesSlice(set, get),
    ...createTicketsSlice(set, get),
    ...createTicketDetailsSlice(set, get),
    ...createContactSlice(set, get),
    ...createNewTicketSlice(set, get),
    ...createUserInfoSlice(set, get),
    ...createNotificationsSlice(set, get)
}));